module.exports = __webpack_public_path__ + "img/stc.b36773ad.jpg";